import menuModalRoutes from 'bento-ordering/menus/routes/modal';
import cartModalRoutes from 'bento-ordering/cart/routes/modal';
import groupOrderRoutes from 'bento-ordering/group_ordering/routes/modal';

const modalRoutes = [
  ...groupOrderRoutes,
  ...cartModalRoutes,
  ...menuModalRoutes
];

export default modalRoutes;
